/** @jsxImportSource @emotion/react */

import CardGame from "components/ui/CardGame";
import HelmetCustom from "components/ui/Helmet";
import ListProvider from "components/ui/ListProvider";
import Search from "components/ui/Search";
import { HeaderUser } from "components/ui/user/HeaderUser";
import { UserWrapperPage } from "components/ui/user/UserWrapperPage";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectDataSubGame } from "store/game";
import { getSubGameList } from "store/game/game.thunks";
import { SubGameType } from "types/game";

import { MyCollectionPageStyle } from "./style.index";

const MyCollectionPage = () => {
  const { t } = useTranslation(["common", "my-collection"]);
  const dispatch = useAppDispatch();
  const { data: dataSubGameListPG } = useAppSelector(selectDataSubGame);

  useEffect(() => {
    dispatch(
      getSubGameList({
        game_type: "SL",
        provider: "PGS2",
        lobby: 0,
        size: 7
      })
    );
  }, []);

  return (
    <UserWrapperPage hasMaxWidth>
      <HelmetCustom title={t("my-collection:page_title")} />
      <HeaderUser title={t("my-collection:header_title")} />
      <Search />
      <ListProvider />
      <div css={MyCollectionPageStyle.result}>
        <h3>{t("my-collection:no_games")}</h3>
        <span>{t("my-collection:recommend_games")}</span>
      </div>
      <div css={MyCollectionPageStyle.recommendGames}>
        {dataSubGameListPG.map((item: SubGameType) => (
          <CardGame key={item.game_code} {...item} />
        ))}
      </div>
    </UserWrapperPage>
  );
};

export default MyCollectionPage;
